<template>
  <validation-observer ref="form">
    <b-form @submit.prevent>
      <b-row class="mt-2">
        <!-- Name -->
        <b-col cols="12">
          <b-form-group
            label="Nombre:"
            label-for="model"
            label-cols-md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Nombre"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="TagIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="model"
                  v-model="item.name"
                  placeholder="Nombre"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Brand -->
        <b-col cols="12">
          <b-form-group
            label="Marca:"
            label-for="brand"
            label-cols-md="4"
          >
            <validation-provider
              #default="{ errors }"
              name="Marca"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="TagIcon" />
                </b-input-group-prepend>
                <b-form-input
                  id="brand"
                  v-model="item.brand"
                  placeholder="Marca"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Comment -->
        <b-col cols="12">
          <b-form-group
            label="Comentario:"
            label-for="comment"
            label-cols-md="4"
          >
            <b-input-group class="input-group-merge">
              <b-form-textarea
                id="comment"
                v-model="item.comment"
                placeholder="Comentario"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Info CreatedAt -->
        <b-col
          v-if="item.id > 0"
          cols="12"
        >
          <b-form-group
            label="Creado:"
            label-for="createdAt"
            label-cols-md="4"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="createdAt"
                :value="$moment.utc(item.createdAt).local().format('DD/MM/YYYY hh:mm:ss a')"
                placeholder="Creado"
                disabled
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- Info UpdatedAt -->
        <b-col
          v-if="item.id > 0"
          cols="12"
        >
          <b-form-group
            label="Actualizado:"
            label-for="updatedAt"
            label-cols-md="4"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                id="updatedAt"
                :value="$moment.utc(item.updatedAt).local().format('DD/MM/YYYY hh:mm:ss a')"
                placeholder="Actualizado"
                disabled
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- btn centered actions-->
        <b-col class="text-center mt-2">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            @click="close"
          >
            Cancelar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="ml-4"
            :disabled="loading"
            @click="save"
          >
            <b-spinner
              v-if="loading"
              small
            />
            {{ loading ? 'Procesando...' : 'Guardar' }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BFormGroup, BFormInput, BForm, BInputGroup, BInputGroupPrepend, BRow, BCol,
  BFormTextarea, BButton, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BFormTextarea,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
      required,
    }
  },
  methods: {
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.$emit('save')
        }
      })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
